<template>
  <v-container
    fluid
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout>
      <v-flex class="mr-1" xs7>
        <v-card class="mb-2">
          <v-flex>
            <v-card flat>
              <funder-enquiry-list></funder-enquiry-list>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs5>
        <v-card class="px-1 pt-0 transparent" flat>
          <v-card-title>
            <div class="title">Advanced Enquiry Search</div>
          </v-card-title>

          <div class="funder-search-container">
            <v-layout wrap>
              <v-flex>
                <v-layout column>
                  <v-subheader>Dates</v-subheader>
                  <v-menu
                    ref="fromMenu"
                    v-model="filterState.startDate.menu"
                    transition="scale-transition"
                    full-width
                    offset-y
                    :return-value.sync="startDate"
                    class="ml-3"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Start date"
                        v-model="prettyStartDate"
                        prepend-inner-icon="event"
                        readonly
                        filled
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      min="2016-05-01"
                      :max="new Date().toISOString().substr(0, 10)"
                      @change="$refs.fromMenu.save(startDate)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="filterState.startDate.menu = false">Cancel</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="toMenu"
                    v-model="filterState.endDate.menu"
                    transition="scale-transition"
                    full-width
                    offset-y
                    :return-value.sync="endDate"
                    class="ml-3"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="End date"
                        v-model="prettyEndDate"
                        prepend-inner-icon="event"
                        readonly
                        filled
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      :min="startDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      @change="$refs.toMenu.save(endDate)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="filterState.endDate.menu = false">
                        Cancel
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout column>
                  <v-subheader>
                    Funding Amount
                  </v-subheader>
                  <v-text-field
                    flat
                    label="Funding minimum"
                    v-model="fundingMinimum"
                    filled
                    hide-details
                    prepend-inner-icon="mdi-currency-gbp"
                    class="ml-3"
                  ></v-text-field>
                  <v-text-field
                    flat
                    label="Funding maximum"
                    v-model="fundingMaximum"
                    filled
                    hide-details
                    prepend-inner-icon="mdi-currency-gbp"
                    class="ml-3"
                    id="maxFunding"
                  ></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-text-field
              name="enquirySearch"
              v-model="enquirySearch"
              prepend-inner-icon="search"
              clearable
              flat
              placeholder="Search Enquiries"
              hide-details
              autocomplete="off"
              class="ml-3 my-3"
            ></v-text-field>
            <v-list dense subheader class="layout row wrap flex transparent">
              <v-list-item>
                <v-subheader>Enquiry Statuses</v-subheader>
              </v-list-item>
              <v-list-item
                v-for="status in orderedStatuses"
                :key="status.id"
                @click="toggleEnquiryStatusFilter(status)"
                :color="FunderEnquiryFilters.enquiryStatuses.includes(status.id) ? 'accent darken-1' : 'grey darken-2'"
                class="xs6 flex"
              >
                <v-list-item-action>
                  <v-checkbox
                    readonly
                    :input-value="FunderEnquiryFilters.enquiryStatuses.includes(status.id)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ status.name | titleCase }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { DateTime } from 'luxon';

import { mapActions, mapGetters } from 'vuex';
import FunderEnquiryList from './FunderEnquiryList';

export default {
  components: {
    FunderEnquiryList
  },
  name: 'funder-enquiries',
  props: ['product'],
  data: () => ({
    filterState: {
      toggles: [],
      owners: [],
      enquiryStatuses: [],
      startDate: {
        menu: false
      },
      endDate: {
        menu: false
      }
    },
    tabStatus: {
      Active: {
        stale: false
      },
      Funded: {
        stale: false
      },
      Inactive: {
        stale: false
      }
    }
  }),
  computed: {
    ...mapGetters([
      'EnquiryLoadingState',
      'EnquiryTotal',
      'FunderEnquiryFilters',
      'OwnerName',
      'PlatformUser',
      'EnquiryStatuses',
      'SelectedFunderEnquiryTab'
    ]),
    startDate: {
      get() {
        return this.FunderEnquiryFilters.dates.from;
      },
      set(value) {
        this.setFunderEnquiryPageFromDate(value).then(() => {
          this.getNewEnquiriesPages();
        });
      }
    },
    endDate: {
      get() {
        return this.FunderEnquiryFilters.dates.to;
      },
      set(value) {
        this.setFunderEnquiryPageToDate(value).then(() => {
          this.getNewEnquiriesPages();
        });
      }
    },
    fundingMinimum: {
      get() {
        return this.currency(this.FunderEnquiryFilters.funding.minimum);
      },
      set: _.debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, ''));
        if (amount < parseInt(this.fundingMaximum.replace(/,/g, ''))) {
          this.setFunderEnquiryPageFundingMinimum(amount).then(() => {
            this.getNewEnquiriesPages();
          });
        }
      }, 100)
    },
    fundingMaximum: {
      get() {
        return this.currency(this.FunderEnquiryFilters.funding.maximum);
      },
      set: _.debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, ''));
        if (amount > 50000000) {
          document.getElementById('maxFunding').value = this.currency(50000000);
        } else if (amount > parseInt(this.fundingMinimum.replace(/,/g, ''))) {
          this.setFunderEnquiryPageFundingMaximum(amount).then(() => {
            this.getNewEnquiriesPages();
          });
        }
      }, 100)
    },
    enquirySearch: {
      get() {
        return this.FunderEnquiryFilters.search;
      },
      set(term) {
        this.setFunderEnquirySearch(term).then(() => {
          this.getNewEnquiriesPages();
        });
      }
    },
    prettyStartDate: function() {
      return _.isNull(this.startDate) ? null : DateTime.fromISO(this.startDate).toLocaleString();
    },
    prettyEndDate: function() {
      return _.isNull(this.endDate) ? null : DateTime.fromISO(this.endDate).toLocaleString();
    },
    orderedStatuses: function() {
      return _.orderBy(this.EnquiryStatuses, 'name');
    }
  },
  methods: {
    ...mapActions([
      'getFunderEnquiries',
      'setFunderFilters',
      'setFunderEnquirySearch',
      'setFunderEnquiryPageFromDate',
      'setFunderEnquiryPageToDate',
      'setFunderEnquiryPageFundingMinimum',
      'setFunderEnquiryPageFundingMaximum',
      'setSelectedFunderEnquiryTab',
      'addFunderEnquiryStatusFilter',
      'removeFunderEnquiryStatusFilter'
    ]),
    getNewEnquiriesPages: _.debounce(function() {
      const enquiryState = _.findKey(this.SelectedFunderEnquiryTab, function(tab) {
        return tab.selected === true;
      });
      _.map(this.tabStatus, function(tabs) {
        tabs.stale = true;
      });
      this.tabStatus[enquiryState].stale = false;
      this.setSelectedFunderEnquiryTab(this.tabStatus);
      this.getFunderEnquiries({ append: false, enquiryState });
    }, 250),
    currency(value) {
      const intValue = typeof value === 'string' ? parseInt(value.replace(/[^\d.]/g, '')) : value;

      return intValue > 0
        ? intValue.toLocaleString({
            style: 'currency',
            currency: 'GBP',
            currencyDisplay: 'symbol',
            minimumSignificantDigits: 0,
            maximumSignificantDigits: 0
          })
        : value;
    },
    toggleEnquiryStatusFilter(status) {
      if (this.FunderEnquiryFilters.enquiryStatuses.includes(status.id)) {
        this.removeFunderEnquiryStatusFilter(status);
      } else {
        this.addFunderEnquiryStatusFilter(status);
      }
      this.getNewEnquiriesPages();
    }
  },
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  },
  mounted() {
    /* _.merge(this.filters, this.FunderEnquiryFilters) */
  }
};
</script>

<style lang="scss" scoped>
.funder-search-container {
  height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

::v-deep .v-list--dense .v-subheader {
  font-weight: 500;
  font-size: 13px;
  height: 40px;
  padding: 0;
}
</style>
